module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-image-fill-7e946f38.svg";